import { Box, Button, Checkbox, CheckboxGroup, Image, Spinner } from '@chakra-ui/react'

import { FormLabel } from './FormLabel'
import { logos } from '../utils/companiesLogos'
import { useContext, useEffect } from 'react'
import { ICompany } from '../utils/companies'
import { Controller, useFormContext } from 'react-hook-form'
import { insuranceParamsContext } from '../layouts/Wizard'
import { SimpleItem } from 'BrokerTsLib/src/dtos'

interface CompanyProps extends ICompany {
  checked?: boolean
}

const CompanyCheckbox = ({ children }: any) => {
  return (
    <Box
      as="label"
      sx={{
        display: 'flex',
        gap: 4,
        alignItems: 'center',
        px: 4,
        py: 1,
        borderRadius: 'sm',
        cursor: 'pointer',
        _hover: {
          backgroundColor: 'gray.50',
        },
      }}
    >
      {children}
    </Box>
  )
}

const getCompaniesState = (companies: Array<ICompany>) => {
  const checkedCompanies = companies.map((company: ICompany) => {
    return {
      ...company,
      checked: false,
    }
  })

  return checkedCompanies
}

export const InsuranceCompanies = ({
  companies = [],
  title,
  tooltip,
  isLoadingCompanies,
  propPath,
  isDisabled = false
}
  : {
    companies: Array<ICompany | SimpleItem>,
    title?: string,
    tooltip?: string,
    isLoadingCompanies: boolean,
    propPath: string,
    isDisabled?: boolean
  }) => {
  const { control, watch, setValue } = useFormContext()
  const { insuranceParamsId: paramsId } = useContext(insuranceParamsContext)!

  const selected = watch(propPath)
  const selectAll = () => (selected?.length ?? -1) === 0

  const handleSelectAll = () => {
    setValue(propPath, selectAll() ? companies.map(comp => comp.id) : [])
  }

  var companiesLength = companies?.length ?? 0
  useEffect(() => {
    if (companiesLength > 0 && !paramsId)
      handleSelectAll()
  }, [paramsId, companiesLength]);

  return (
    <Box>
      <Box as="header" sx={{ display: 'flex', gap: 4, mb: 4 }}>

        <FormLabel tooltip={tooltip}>{title ?? 'Pojišťovny'}</FormLabel>

        {companiesLength > 1 && !isDisabled && <Button type="button" variant="outline" size="sm" onClick={handleSelectAll}>
          {selectAll() ? 'Vybrat vše' : 'Zrušit výběr'}
        </Button>}

        {isLoadingCompanies && <Spinner />}
      </Box>

      <Controller
        name={propPath}
        control={control}
        render={({ field: { onChange, value } }) => (
          <CheckboxGroup
            onChange={values => onChange(values.map(val => parseInt(val.toString())))}
            value={value}
            isDisabled={isDisabled}
          >
            <Box as="main" sx={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
              {companies && companies.map(({ id, name }: CompanyProps) => {
                const logo: string = (logos as any)[id]

                return (
                  <CompanyCheckbox key={id}>
                    <Checkbox value={id} />

                    <Image src={logo} alt={name} title={name} width="64px" height="48px" />
                  </CompanyCheckbox>
                )
              })}
            </Box>
          </CheckboxGroup>
        )
        }
      />
    </Box >
  )
}
